import { render, staticRenderFns } from "./groupQuestionSelector.vue?vue&type=template&id=1c4d5591&scoped=true"
import script from "./groupQuestionSelector.vue?vue&type=script&lang=js"
export * from "./groupQuestionSelector.vue?vue&type=script&lang=js"
import style0 from "./groupQuestionSelector.vue?vue&type=style&index=0&id=1c4d5591&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4d5591",
  null
  
)

export default component.exports